import revive_payload_client_4sVQNw7RlN from "/var/www/html/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/html/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/html/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import plugin_vue3_A0OWXRrUgq from "/var/www/html/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/www/html/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/html/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/html/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import floating_zzW5zaa1LU from "/var/www/html/plugins/floating.ts";
import api_GFfDXud5Cr from "/var/www/html/plugins/api.ts";
import buffer_aHHLuY3sF2 from "/var/www/html/plugins/buffer.ts";
import emitter_eaMgM0oZTb from "/var/www/html/plugins/emitter.ts";
import loki_client_TiBC0tacMY from "/var/www/html/plugins/loki.client.ts";
import sentry_client_shVUlIjFLk from "/var/www/html/plugins/sentry.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  floating_zzW5zaa1LU,
  api_GFfDXud5Cr,
  buffer_aHHLuY3sF2,
  emitter_eaMgM0oZTb,
  loki_client_TiBC0tacMY,
  sentry_client_shVUlIjFLk
]